import { GOOGLE_SHEET_URL } from "./googleSheet";

/**
 * POST helper generik ke Apps Script.
 * Apps Script doPost baca lewat e.parameter, jadi kita kirim sebagai
 * application/x-www-form-urlencoded (bukan JSON).
 */
async function postAction(params: Record<string, string | number>) {
  const body = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    body.append(key, String(value));
  });

  const res = await fetch(GOOGLE_SHEET_URL, {
    method: "POST",
    body,
  });

  return res.json();
}

export function toggleLike(aspirasiId: number | string, deviceId: string) {
  return postAction({
    action: "like",
    aspirasi_id: aspirasiId,
    device_id: deviceId,
  });
}

export function tambahKomentar(aspirasiId: number | string, deviceId: string, nama: string, komentar: string) {
  return postAction({
    action: "tambah_komentar",
    aspirasi_id: aspirasiId,
    device_id: deviceId,
    nama,
    komentar,
  });
}

export function editKomentar(id: number | string, deviceId: string, komentar: string) {
  return postAction({
    action: "edit_komentar",
    id,
    device_id: deviceId,
    komentar,
  });
}

export function hapusKomentar(id: number | string, deviceId: string) {
  return postAction({
    action: "hapus_komentar",
    id,
    device_id: deviceId,
  });
}
